import { Menu, X, Instagram, Twitter, Youtube } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import type { NavigationItem } from '../../types';

const navigation: NavigationItem[] = [
  { name: 'Home', href: '/' },
  { name: 'News', href: '/news' },
  { name: 'History', href: '/history' },
  { name: 'Weather', href: '/weather' },
  { name: 'Fixtures', href: '/fixtures' },
  { name: 'Results', href: '/results' },
  { name: 'Contact', href: '/contact' },
];

const socialLinks = [
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/moldefotballklubb/',
    icon: Instagram
  },
  {
    name: 'Twitter',
    href: 'https://x.com/Molde_FK',
    icon: Twitter
  },
  {
    name: 'YouTube',
    href: 'https://www.youtube.com/channel/UCP8HqD2euT1TUgXWVaT1fiQ',
    icon: Youtube
  }
];

export function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header>
      {/* Top bar */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-end h-10 items-center space-x-6">
            {socialLinks.map((item) => (
              <a
                key={item.name}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-[#2173B9] transition-colors"
                aria-label={item.name}
              >
                <item.icon className="w-5 h-5" />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Main navigation */}
      <nav className="bg-[#2173B9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-24">
            <div className="flex-shrink-0 flex items-center">
              <Logo />
            </div>

            {/* Desktop navigation */}
            <div className="hidden lg:flex lg:items-center lg:-mt-2">
              <div className="flex space-x-8">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className="text-white hover:text-white/80 px-3 py-2 text-base font-medium"
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </div>

            {/* Mobile menu button */}
            <div className="flex items-center lg:hidden">
              <button
                type="button"
                className="text-white hover:text-white/80 p-2"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              >
                {mobileMenuOpen ? (
                  <X className="h-8 w-8" />
                ) : (
                  <Menu className="h-8 w-8" />
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden">
            <div className="px-4 pt-2 pb-3 space-y-2">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="text-white hover:text-white/80 block px-3 py-2 text-lg font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
